import React, { ForwardRefRenderFunction } from 'react';
import { useAppSelector } from '@/redux';

import Icon from '@/components/common/iconedLinks/Icon';

import styles from './CheckMarkedContainer.module.scss';
import { URLS } from '@/constants/urls';

type CheckMarkedContainerProps = {
  id?: string;
  selected?: any;
  onSelect?: (selected: any) => void;
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
}

const InnerComponent: ForwardRefRenderFunction<HTMLDivElement, CheckMarkedContainerProps> = (
  ({ id, selected, onSelect, children }, ref): React.JSX.Element => {
    const incompatibleProducts = useAppSelector(({ checkout }) => checkout .incompatibleProducts);
    const checkingIncompatibleProducts = useAppSelector(({ checkout }) => checkout .checkingIncompatibleProducts);

    const computedClassName = [
      styles.checkmarked,
      checkingIncompatibleProducts || !selected ? '' :
        incompatibleProducts.length > 0 ? styles['selected-incompatible'] : styles.selected
    ].filter(Boolean).join(' ');

    return (
      <div
        ref={ref}
        data-rbf={id}
        className={computedClassName}
        data-test-id="checkmarked"
        onClick={(e) => !selected && onSelect(e)}
      >
        {selected && !checkingIncompatibleProducts && (
          <div className={`${styles.checkmark}${incompatibleProducts.length > 0 ? ' ' + styles.incompatible : ''}`} data-test-id="checkmark">
            <Icon src={URLS.ICON_CHECKMARK_WHITE} alt="checked" width={10} height={10} />
          </div>
        )}
        {React.cloneElement(children, { selected })}
      </div>
    );
  }
);

InnerComponent.displayName = 'CheckMarkedContainer';

// TODO-TYPESCRIPT : trouver un moyen d'enlever ce any
const CheckMarkedContainer = React.forwardRef(InnerComponent) as any;
export default React.memo(CheckMarkedContainer);
